import { doPost } from "../api/baseAPI";
import { GROLOG_URL } from "../constant/apiConstant"

export const POSTGetListServices = async (token, api_contract, body) => {
  const url = `${GROLOG_URL}/${api_contract}`;
  let result = { 
    success: false, 
    list: undefined, 
    errorCode: undefined, 
    message: undefined 
  }

  try {
    const response = await doPost(url, token, body);
    if (response) {
      result.success = true;
      result.list = response?.data?.payload?.data;
      result.message = response?.data?.payload?.status?.message;
      delete result.errorCode;
    }
  } catch (error) {
    console.log(error);
    result.success = false;
    // result.errorCode = error?.response?.data?.payload?.status?.code;
    delete result.list;
  }
return result
}